import React, { FC, useMemo } from 'react';
import FinanceElementsTypes from '../../../../../../../../common/enum/FinanceElementsTypes';
import { Box, useTheme } from '@material-ui/core';
import InterestRateContainer from './interestRate/InterestRateContainer';
import ComparisonRateContainer from './comparisonRate/ComparisonRateContainer';
import ChosenRateContainer from './chosenRate/ChosenRateContainer';
import ChosenTermContainer from './chosenTerm/ChosenTermContainer';
import TermContainer from './termContainer/TermContainer';
import { IFinanceQuote } from '../../../../../../common/model/IFinanceQuote';
import { useSelector } from 'react-redux';
import currentDealSelectors from '../../../../../store/selectors/currentDealSelectors';
import informativeSectionContainerStyles from './informativeSectionContainerStyles';
import TermInYearsContainer from './termInYears/TermInYearsContainer';
import DepositPercentageContainer from './depositPercentage/DepositPercentageContainer';
import MonthlyInterestContainer from './monthlyInterest/MonthlyInterestContainer';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';

// Please not that most of the containers are rendering <Rate /> if needed that can be changed
const MappedFinanceElements: Partial<Record<FinanceElementsTypes, JSX.Element>> = {
  [FinanceElementsTypes.INTEREST_RATE]: <InterestRateContainer />,
  [FinanceElementsTypes.COMPARISON_RATE]: <ComparisonRateContainer />,
  [FinanceElementsTypes.CHOSEN_RATE]: <ChosenRateContainer />,
  [FinanceElementsTypes.CHOSEN_TERM]: <ChosenTermContainer />,
  [FinanceElementsTypes.TERM]: <TermContainer />,
  [FinanceElementsTypes.TERM_IN_YEARS]: <TermInYearsContainer />,
  [FinanceElementsTypes.DEPOSIT_PERCENTAGE]: <DepositPercentageContainer />,
  [FinanceElementsTypes.MONTHLY_INTEREST]: <MonthlyInterestContainer />,
};

const InformativeSectionContainer: FC = () => {
  const styles = informativeSectionContainerStyles();
  const financeQuote: IFinanceQuote = useSelector(currentDealSelectors.getFinanceQuote);
  const isCashProduct = useMemo(() => !financeQuote || financeQuote.isCashProduct, [financeQuote]);
  const {
    spc: {
      customise: { availableFinanceElements },
    },
  } = useTheme<ISpcTheme>();

  if (isCashProduct) {
    return null;
  }

  return (
    <Box display="flex" className={styles.container}>
      {(availableFinanceElements || [FinanceElementsTypes.INTEREST_RATE]).map(element => (
        <Box className={styles.informativeItem} key={element}>
          {MappedFinanceElements[element]}
        </Box>
      ))}
    </Box>
  );
};

export default InformativeSectionContainer;
